/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ failed: NonNullable<unknown> }} Spaces_Wizard_Toast_Users_Add_Partial_ErrorInputs */



/**
* | output |
* | --- |
* | "Failed to add {failed} user(s) to the project." |
*
* @param {Spaces_Wizard_Toast_Users_Add_Partial_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_wizard_toast_users_add_partial_error = /** @type {((inputs: Spaces_Wizard_Toast_Users_Add_Partial_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Wizard_Toast_Users_Add_Partial_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.failed} Benutzer konnten nicht zum Projekt hinzugefügt werden.`)
	return /** @type {LocalizedString} */ (`Failed to add ${i?.failed} user(s) to the project.`)
});